import '@babel/polyfill';
import 'mutationobserver-shim';
import Vue from 'vue';
import './plugins/bootstrap-vue';
import App from './AppS.vue';
import router from './router';
import store from './vuex/store';
import upperFirst from 'lodash/upperFirst';
import camelCase from 'lodash/camelCase';
import moment from 'moment';

import Service from '@/services/Service';

const requireComponent = require.context(
  './components',
  false,
  /Base[A-Z]\w+\.(vue|js)$/
);

requireComponent.keys().forEach(fileName => {
  const componentConfig = requireComponent(fileName);

  const componentName = upperFirst(
    camelCase(fileName.replace(/^\.\/(.*)\.\w+$/, '$1'))
  );

  Vue.component(componentName, componentConfig.default || componentConfig);
});

Vue.config.productionTip = false;

Vue.filter('formatDate', function(value) {
  if (value) {
    return moment(String(value)).format('ddd D MMM YYYY');
  }
});

Vue.filter('formatTime', function(value) {
  if (value) {
    return moment(String(value)).format('h:mm A');
  }
});

new Vue({
  router,
  store,

  created() {
    const sessionString = localStorage.getItem('session'); // grab user data from local storage
    if (sessionString) {
      // check to see if there is indeed a user
      const session = JSON.parse(sessionString); // parse user data into JSON
      this.$store.commit('SET_SESSION', session); // restore user data with Vuex
      this.$store.dispatch('ensureSession'); // set the session id on the service auth header
      this.$store.dispatch('loadBasket'); // load the basket
    }
    Service.setErrorHandler(function errorHandler(error, store) {
      if (error.response.status === 401) {
        // if we catch a 401 error and are logged in
        store.dispatch('logout'); // force a log out
        store.dispatch('addMessage', {
          message: 'Session Expired'
        });
      } else {
        console.log(error.response);
        throw error;
      }
    }, this.$store);
  },
  render: h => h(App)
}).$mount('#app');
